// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2WZSG","unreadBadge":"styles_unreadBadge__1Pu8N","modalContent":"styles_modalContent__pDOmX","modal":"styles_modal__1AxjP"};